/**
 * Header-komponent
 */

import React from 'react';
import { Activity } from 'lucide-react';

export const Header = ({ profile, onProfileClick }) => {
  return (
    <header className="bg-white border-b sticky top-0 z-20 px-4 h-16 flex items-center justify-between">
      <div className="flex items-center gap-2">
        <div className="bg-orange-600 p-1.5 rounded-lg shadow-sm">
          <Activity className="text-white w-5 h-5" />
        </div>
        <h1 className="font-black text-xl tracking-tighter uppercase text-slate-800">
          LØPDA
        </h1>
      </div>
      
      {profile && (
        <button 
          onClick={onProfileClick}
          className="flex items-center gap-2 bg-slate-100 p-1 pr-3 rounded-full hover:bg-slate-200 transition-colors border border-slate-200/50"
        >
          <span className="text-xl ml-1">{profile.avatar}</span>
          <span className="text-[10px] font-black uppercase text-slate-500 hidden sm:block">
            {profile.name || "Min Profil"}
          </span>
        </button>
      )}
    </header>
  );
};
